import { PencilSimpleLine } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { PricingProfilePricingType } from 'pricing/enums';
import { IPricingProfile } from 'pricing/types';
import { Variant } from 'theme/enums';

import { UpdatePricingProfiles } from './UpdatePricingProfiles';

interface IProps {
  type: PricingProfilePricingType;
  pricingProfile: IPricingProfile;
  onSuccess?: () => void;
}

export const UpdatePricingProfileButton = ({ type, pricingProfile, onSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelEditProfileDetails')}
        variant={Variant.OUTLINED}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
      />

      <UpdatePricingProfiles
        type={type}
        pricingProfiles={[pricingProfile]}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSuccess}
      />
    </>
  );
};
